// extracted by mini-css-extract-plugin
module.exports = {"note":"JstTimeNote_note_1VHHt"};